// extracted by mini-css-extract-plugin
export default {"avatar-container":"AvatarWithScene_avatar-container__dgR5m"};